import React, { useState } from "react";
import { Box } from "rizzui/box";
import { Text } from "rizzui/typography";
import cn from "../../lib/utils/class-name";
import ChangePassword from "./components/password";
import Billing from "./components/billing";
import Team from "./components/team";
import Integration from "./components/integration";
import Notification from "../../component/notification";
import { Button } from "rizzui/button";
import PhoneNumbers from "./components/phone";
import { useModal } from "../../hooks/useModal";
import AddCardForm from "../../component/addCard";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import ProfilePage from "./components/profile";
import { useLocation, useNavigate } from "react-router-dom";
import { useNotifcication } from "../../hooks/useNotification";

export const notificationHeaderClassName =
  "font-[500] text-[16px] font-switzer text-[#191919] leading-[21.12px]";
export const notificationTextClassName =
  "font-[400] text-[12px] font-switzer text-[#191919] leading-[15.84px]";

export default function Settings() {
  const [currentPage, setCurrentPage] = useState(0);
  const { openNotification } = useNotifcication();
  const location = useLocation();
  const navigate = useNavigate();
  const from = location.state?.from;
  React.useEffect(() => {
    if (from === "sidebar" || from === "paystack") {
      setCurrentPage(2);
    }
    if (from === "paystack") {
      const message = location.state?.message;
      const status = location.state?.error ? "error" : "success";
      if (message && status) {
        openNotification({
          message,
          status,
        });
      }
    }
    navigate(location.pathname, { replace: true });
  }, [from]);

  const linkClassName =
    "font-[500] cursor-pointer border-primary-dark font-switzer text-[16px] leading-[22px] py-[10px] px-[24px] text-primary-dark";
  const conditionalComponent = () => {
    switch (currentPage) {
      case 0:
        return <ProfilePage />;
      case 1:
        return <ChangePassword />;
      case 2:
        return <Billing />;
      case 3:
        return <Integration />;
      case 4:
        return <PhoneNumbers />;
      default:
        return;
    }
  };
  const pages = [
    "profile",
    "password",
    "billing",
    "integration",
    "phone numbers",
  ];
  return (
    <div>
      {currentPage === 26 && <NotificationPopUp />}
      <Box className="flex gap-[12px] border-b-[.5px] border-[#D1D6DD] overflow-x-auto">
        {pages.map((page, i) => {
          return (
            <Text
              key={i}
              className={cn(
                linkClassName,
                currentPage === i ? "border-b-[3px]" : ""
              )}
              onClick={() => setCurrentPage(i)}
            >
              {page.slice(0, 1).toUpperCase() + page.slice(1)}
            </Text>
          );
        })}
      </Box>
      {conditionalComponent()}
    </div>
  );
}

export function NotificationPopUp() {
  const stripePromise = loadStripe(
    "pk_live_51RBMC2GrAUloA055J59lQo43bzamh2aCaDxUvNrcZN77ch0jG4JaiBklj0cBVB9VrsMW0cW8A0gtMIhoKAUF9KX600U8NcaPE7"
    /*"pk_test_51RBMCK2etvGWGnrmPNdwl2LdhJNTtDHMBemtAoVZXXqp7KZHT02BDIl1O7O6D4TpQx73vA4VYipsOipTtDG2jiyv00UTmz8H2t"*/
  );
  const { openModal } = useModal();
  const btnClassName =
    "min-w-[135px] h-[35px] bg-[#191919] hover:bg[#191919] dark:bg-btn hover:dark:bg-btn text-background hover:text-background rounded-[4px]";
  const btnTextClassName =
    "text-[12px] font-switzer font-[500] text-background";
  return (
    <Notification>
      <div className="flex justify-between">
        <div className="flex flex-col gap-[6px]">
          <Text className={notificationHeaderClassName}>
            We couldn’t charge your card
          </Text>
          <Text className={notificationTextClassName}>
            We attempted to process your monthly payment, but there was an issue
            with your card. Please try using a different card.
          </Text>
        </div>

        <Button
          variant="text"
          className={btnClassName}
          onClick={() =>
            openModal({
              view: (
                <Elements stripe={stripePromise}>
                  <AddCardForm />
                </Elements>
              ),
            })
          }
        >
          <Text className={btnTextClassName}>Update your card</Text>
        </Button>
      </div>
    </Notification>
  );
}
